import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_POST_PRTC_DETAILS_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_POST_PRTC_DETAILS_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_POST_PRTC_DETAILS_FAILURE`;
export const photoCaptureIntelligentPostPrtcDetailsRequestAction = (request) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_REQUEST,
    payload: { request }
});
export const photoCaptureIntelligentPostPrtcDetailsSuccessAction = (response) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_SUCCESS,
    payload: { response }
});
export const photoCaptureIntelligentPostPrtcDetailsFailureAction = failureMessage => ({
    type: INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=photoCaptureIntelligentPrtcDetailsAction.js.map